import React from 'react'

import ContactBan from './img/Images/flag.webp';


import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';
import Email from './Contact-Form';


function Contact() {
  return (
    <>
    <Helmet>
    <title>Acoustics</title>
                <meta name="title" content="Content here" />
                <meta name="description" content="Content here" />
                <meta name="keywords" content="Content here" />
                <meta property="og:title" content="About og title" />
                <meta property="og:description" content="og-description" />
            </Helmet>
      <Header />

   

<div className='welcome-container-contact'>
       


        <div className='acu-col-top-contact'><div className='acu-copy-abt'><h1>Contact us</h1>

          <h3>Please contact us for any technical advice or project specific enquires.<br/>Email: <a href="mailto:enquiries@acoustic.com.au">enquiries@acoustic.com.au</a><br/>Phone: 08-6156 6750</h3></div>
          </div>


      </div>

      <div className='welcome-container-contact'>
        <div className='acu-col-contact'><img src={ContactBan} alt="Acoustics"/></div>


        <div className='acu-col-right-abt2'><iframe src="https://www.acoustic.com.au/connect/connect" title="contact" id="my-iframe" class="cframe" marginwidth="0" marginheight="0" frameborder="0" scrolling="no"></iframe>
          </div>


      </div>

  

   
     
       

   

    

      



<Footer />
 
    </>
  )
}

export default Contact
